import { Helmet } from 'react-helmet-async';

const SITE = 'GC3H Online Canteen';
const BASE = 'https://gc3honlinecanteen.co.za';

/**
 * Per-page SEO tags (title, description, canonical, Open Graph).
 * Gives every public route a unique title + meta description for search engines.
 */
export default function Seo({ title, description, path = '', image }) {
  const fullTitle = title ? `${title} | ${SITE}` : SITE;
  const url = `${BASE}${path}`;
  const ogImage = image || `${BASE}/gc3h-qr-code.png`;
  return (
    <Helmet prioritizeSeoTags>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={ogImage} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
    </Helmet>
  );
}
